import { useState } from "react";

const useConfirmDelete = () => {
  let [askDelete, setAskDelete] = useState(false);

  const handleConfirmDelete = () => {
    setAskDelete(true);
  };

  const handleInfirmDelete = () => {
    setAskDelete(false);
  };

  return { askDelete, handleConfirmDelete, handleInfirmDelete };
};

export default useConfirmDelete;
